import Vue from 'vue';
import IncomingCallDialog from '@/components/IncomingCallDialog.vue';

const IncomingCallDialogPlugin = {
  install(Vue) {
    // 创建组件构造器
    const DialogConstructor = Vue.extend(IncomingCallDialog);
    let instance;

    // 全局方法：打开弹窗
    function $showIncomingCallDialog() {
      if (!instance) {
        // 创建实例并挂载到 body
        instance = new DialogConstructor();
        instance.$mount();
        document.body.appendChild(instance.$el);
      }
      // 返回 Promise 以便获取用户操作
      return instance.show();
    }

    function $hideIncomingCallDialog() {
        if (!instance) {
          // 创建实例并挂载到 body
          instance = new DialogConstructor();
          instance.$mount();
          document.body.appendChild(instance.$el);
        }
        // 返回 Promise 以便获取用户操作
        return instance.hide();
      }

    // 挂载到 Vue 原型
    Vue.prototype.$showIncomingCallDialog = $showIncomingCallDialog;
    Vue.prototype.$hideIncomingCallDialog = $hideIncomingCallDialog;
  }
};

export default IncomingCallDialogPlugin;